import { lazy, Suspense } from "react";
import type { RouteConfig } from "./types";

const ShiftReportPage = lazy(() => import("@/pages/shift-report"));

const shiftReportElement = (
  <Suspense fallback={null}>
    <ShiftReportPage />
  </Suspense>
);

export const shiftReportRoutes: RouteConfig[] = [
  {
    path: "/shift-report",
    element: shiftReportElement,
    permission: "ui.navbar.meltshop",
  },
  {
    path: "/shift-report/:shiftId",
    element: shiftReportElement,
    permission: "ui.navbar.meltshop",
  },
];
